import Select from 'react-select';
import { useState } from 'react';
import { UpdateElementLink, checkFormula } from '@store/HR/Payroll/ElementLinkSlice';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useGetAccounts from '@hooks/Finance/ChartAccountsDetails/useGetAccounts';
import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { useAppDispatch } from '@store/hooks';
import CodeInput from './CodeInput';
import { useParams } from 'react-router-dom';
import useGetElementLink from '@hooks/Payrolls/useGetElementLink';
import { Card, CardBody } from '@components/card/card';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import useGetStaticElement from '@hooks/Payrolls/useGetStaticElement';
import Loading from '@components/Shared/Loader/Loading';
import useGetPayrollCondition from '@hooks/Payrolls/useGetPayrollCondition';

const UpdateLink = ({ item }: { item: any }) => {
  const { id: payrollId } = useParams();

  const [loadingCheck, setLoadingCheck] = useState<boolean>(false);
  const [formulaStatus, setFormulaStatus] = useState<'not-checked' | 'valid' | 'invalid'>(
    'not-checked'
  );
  const [resultCheckFormula, setResultCheckFormula] = useState<number | null>(null);

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { OptionsAccounts, loading: LoadingAccounts } = useGetAccounts();

  const { elementCodes , elementLink } = useGetElementLink(payrollId ?? '');
  const { StaticElementCode, loading: loading2, error: error2 } = useGetStaticElement();
  console.log(elementLink);
  
  const {
    PayrollConditionCodes,
    loading: loading3,
    error: error3
  } = useGetPayrollCondition(payrollId);

  const formik = useFormik({
    initialValues: {
      id: item.id ?? '',
      priority: item.priority ?? '',
      isActive: item.isActive ?? false,
      transferToGl: item.transferToGl ?? false,
      accountId: item.accountId ?? '',
      // formula: item.formula ?? ''
      formula: item.formula?.replace(/;\s*/g, ';\n') ?? ''
      // elementTypeId: item.elementTypeId ?? ''
    },
    enableReinitialize: true,
    onSubmit: values => {
      dispatch(
        UpdateElementLink({
          id: values.id,
          priority: values.priority,
          formula: values.formula,
          isActive: values.isActive,
          transferToGl: values.transferToGl,
          accountId: values.transferToGl === false ? null : values.accountId
        })
      )
        .unwrap()
        .then(() => {
          formik.resetForm();
          CustomAlert({ action: 'Edit' });
          // dispatch(GetElementLinkDeatail(id));
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
          console.log(error);
        });
    }
    // validate: values => {
    //   const errors = {};
    //   if (!values.elementTypeId) {
    //     errors.elementTypeId = 'Please select an option';
    //   }
    //   return errors;
    // }
  });

  // console.log(formik.values);

  const handleCheckFormula = async () => {
    setLoadingCheck(true); // بدء حالة التحميل

    try {
      const check = await dispatch(
        checkFormula({
          formula: formik.values.formula.trim(),
          priority: formik.values.priority,
          payrollId: payrollId
        })
      ).unwrap();

      setFormulaStatus(check.succeeded ? 'valid' : 'invalid');
      setResultCheckFormula(check.succeeded ? check.data : null);
    } catch (error) {
      console.error('Error checking formula:', error);
      setFormulaStatus('invalid');
    } finally {
      setLoadingCheck(false); // إنهاء حالة التحميل
    }
  };
  const radios = [
    { name: t('تفعيـل'), value: true, icon: 'fa-check-circle' },
    { name: t('إلغـاء التفعيـل'), value: false, icon: 'fa-times-circle' }
  ];
  const radiosGl = [
    { name: t('ترحيل إلى الماليـة'), value: true, icon: 'fa-money-bill-transfer' }, // Money transfer icon
    { name: t('عدم الترحيل إلى المالية'), value: false, icon: 'fa-circle-xmark' } // X mark icon
  ];

  return (
    <>
      <Loading loading={loading2} error={error2}>
        <Form onSubmit={formik.handleSubmit}>
          <div className='row mb-3'>
            {/* General Settings Section */}
            <div className='col-md-12 col-lg-6 mb-3 mb-lg-0'>
              <Card className='h-100 border-theme'>
                <CardBody>
                  <h6 className='card-title mb-3'>
                    <i className='fa fa-cog text-theme me-2'></i> {t('الإعدادات العامة')}
                  </h6>
                  <hr />

                  <div className='row align-items-center'>
                    <div className='col-12'>
                      <div className='d-flex w-100 gap-3'>
                        <ButtonGroup className='w-100'>
                          {radios.map((radio, idx) => (
                            <ToggleButton
                              className='w-100 d-flex align-items-center justify-content-center gap-2'
                              key={idx}
                              id={`radio-${idx}`}
                              type='radio'
                              variant={'outline-theme'}
                              name='isActive'
                              value={''}
                              checked={formik.values.isActive === radio.value}
                              onChange={() => formik.setFieldValue('isActive', radio.value)}
                            >
                              <i className={`fa ${radio.icon} me-1`}></i> {radio.name}
                            </ToggleButton>
                          ))}
                        </ButtonGroup>
                      </div>
                    </div>

                    <div className='col-12 mt-4'>
                      <div className='input-group flex-nowrap'>
                        <span className='input-group-text fw-bold'>{t('الأولويـة')}</span>
                        <Form.Control
                          className='form-control text-center'
                          type='number'
                          autoComplete='off'
                          name='priority'
                          onChange={formik.handleChange}
                          value={formik.values.priority}
                          isInvalid={!!(formik.touched.priority && formik.errors.priority)}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            {/* Finance Transfer Section */}
            <div className='col-md-12 col-lg-6'>
              <Card className='h-100 border-theme'>
                <CardBody>
                  <h6 className='card-title mb-3'>
                    <i className='fa fa-calculator text-theme me-2'></i> {t('الترحيل للماليـة')}
                  </h6>
                  <hr />

                  <div className='row align-items-center'>
                    <div className='col-12'>
                      <div className='d-flex w-100 gap-3'>
                        <ButtonGroup className='w-100'>
                          {radiosGl.map((radio, idx) => (
                            <ToggleButton
                              className='w-100 d-flex align-items-center justify-content-center gap-2'
                              key={idx}
                              id={`radioGl-${idx}`}
                              type='radio'
                              variant={'outline-theme'}
                              name='transferToGl'
                              value={''}
                              checked={formik.values.transferToGl === radio.value}
                              onChange={() => formik.setFieldValue('transferToGl', radio.value)}
                            >
                              <i className={`fa ${radio.icon} me-1`}></i> {radio.name}
                            </ToggleButton>
                          ))}
                        </ButtonGroup>
                      </div>
                    </div>

                    <div className='col-12 mt-4'>
                      <div className='form-group mb-3 '>
                        <Select
                          isDisabled={!formik.values.transferToGl}
                          classNamePrefix='react-select'
                          // className='w-100 '
                          className={`w-100 ${
                            !formik.values.transferToGl ? 'bg-light bg-opacity-25 text-muted' : ''
                          }`}
                          isLoading={LoadingAccounts}
                          isSearchable={true}
                          isClearable
                          options={OptionsAccounts}
                          placeholder={i18n.language === 'ar' ? 'إختر الحســاب' : 'Choose Accounts'}
                          onChange={option => {
                            formik.setFieldValue(
                              'accountId',
                              option === null ? null : option.value
                            );
                          }}
                          value={
                            formik.values.transferToGl
                              ? OptionsAccounts?.find(f => f.value === formik.values.accountId)
                              : null
                          }
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>

          {/* صياغة معادلة  */}
          <div className='mt-2 border border-1 border-theme'>
            <div className='d-flex justify-content-between align-items-center mb-1 p-1 '>
              <h6 className='m-0'>
                <i className='fa fa-calculator text-theme me-2'></i>
                صيـاغة المعادلة #C
              </h6>

              {formulaStatus !== 'not-checked' && (
                <div>
                  {formulaStatus === 'valid' ? (
                    <span>
                      <i className='fas fa-check-circle' style={{ color: 'green' }}></i> الصيغة
                      صحيحة
                    </span>
                  ) : (
                    <span>
                      <i className='fas fa-times-circle' style={{ color: 'red' }}></i> الصيغة غير
                      صحيحة
                    </span>
                  )}

                  <span className='ms-2 bg-success bg-opacity-25 rounded fw-bold'>
                    {resultCheckFormula}
                  </span>
                </div>
              )}

              <button
                disabled={!formik.values.formula || !formik.values.priority || loadingCheck}
                type='button'
                className='btn btn-sm btn-theme m-0'
                onClick={handleCheckFormula}
                title='Check Formula'
              >
                {loadingCheck ? (
                  <span
                    className='spinner-border spinner-border-sm '
                    role='status'
                    aria-hidden='true'
                  ></span>
                ) : (
                  <i className='fa fa-bolt m-1 '></i>
                )}
              </button>
            </div>
            {elementCodes?.length > 0 && StaticElementCode?.length > 0 && (
              <CodeInput
                formik={formik}
                elementCodes={elementCodes}
                StaticElementCode={StaticElementCode}
                PayrollConditionCodes={PayrollConditionCodes}
              />
            )}
          </div>

          {/* buttonس */}
          <div className='text-center mt-3'>
            <div className='d-flex justify-content-between gap-2'>
              <button
                disabled={formik.isSubmitting}
                type='submit'
                className='btn btn-lg btn-theme mb-1 w-100 rounded-1'
              >
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='fas fa-save fa-lg fa-fw me-2'></i>
                )}
                {t('Save')}
              </button>

              <button
                type='button'
                className='btn btn-lg  btn-default mb-1 w-100 rounded-1'
                data-bs-dismiss='modal'
              >
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </div>
        </Form>
      </Loading>
      <style>{`
      
      .btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show { 

        border-color: rgba(var(--bs-theme-rgb), 1);
        background-color: rgba(var(--bs-theme-rgb), 1) ;
        }

      `}</style>
    </>
  );
};

export default UpdateLink;
// color: var(--bs-btn-active-color);
// background-color: var(--bs-btn-active-bg);
// border-color: var(--bs-btn-active-border-color);
